// extracted by mini-css-extract-plugin
module.exports = {"dialogBtnBox":"payRiskModal_dialogBtnBox__0Mr0_","primaryBtn":"payRiskModal_primaryBtn__QDhCY"};